import React from 'react';
import Image from 'next/image';

import { formatCurrency, formatCurrencyWithTwoDecimals, importStatic } from 'utils';

import classes from './incomeByGender.module.css';

const IncomeByGender = ({ outsideTitle, sectionTitle, jobTitle, incomeByGender }) => {
  const renderInsideTitle = () => {
    if (!outsideTitle) {
      return (
        <h3 className="cmpSectionh4 text-capitalize">
          {sectionTitle || `${jobTitle} Gender Pay Gap`}
        </h3>
      );
    }

    const femaleIncomeToMaleIncomeRatio = incomeByGender.Female / incomeByGender.Male;
    let femaleEarn = formatCurrencyWithTwoDecimals(femaleIncomeToMaleIncomeRatio);
    if (femaleIncomeToMaleIncomeRatio < 1) {
      femaleEarn = `${(femaleIncomeToMaleIncomeRatio * 100).toFixed()}¢`;
    }
    return (
      <p className="cmpSectionh4 font-weight-normal text-capitalize">{`Women earn ${femaleEarn} for every $1 earned by men`}</p>
    );
  };

  const renderOutsideTitle = () => {
    if (outsideTitle) {
      return <h3 className="cmpSectionh4 z-mb-24 text-capitalize">{outsideTitle}</h3>;
    }
  };

  return (
    <>
      {renderOutsideTitle()}
      <div className={classes['income-by-gender']}>
        {renderInsideTitle()}
        <div className="d-flex flex-column flex-md-row mt-4">
          <div className="d-flex mr-0 mr-md-5">
            <Image
              width="80"
              height="80"
              src={importStatic('/ui-router/images/male-income.svg')}
              alt="male-income"
            />
            <div className="z-ml-15">
              <div className="mb-1 openSansNormal">Male Income</div>
              <div className="brandonH2">{formatCurrency(incomeByGender['Male'])}</div>
            </div>
          </div>
          <div className="d-flex mt-4 mt-md-0">
            <Image
              width="80"
              height="80"
              src={importStatic('/ui-router/images/female-income.svg')}
              alt="female-income"
            />
            <div className="z-ml-15">
              <div className="mb-1 openSansNormal">Female Income</div>
              <div className="brandonH2">{formatCurrency(incomeByGender['Female'])}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IncomeByGender;
